import { Services } from '@sigma-frontend-libs/commons'

import entity from '@/components/entity'
import divider from '@/components/g/divider'
import { serviceNameKebabCase, serviceNameViaPoint } from '@/components/services/report-manager/queue/utils'

function renderTitle(h) {
  return h(
    'span',
    {},
    [ this.getTranslate(`${serviceNameViaPoint}.labels.dateRange`) ]
  )
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form-readonly__subheader`
    },
    [
      renderTitle.call(this, h),
      h(divider)
    ]
  )
}

function renderContent(h) {
  return h(
    entity,
    {
      props: {
        value: this.fields,
        service: Services['report-manager/queue'],
        fields: Object.keys(this.fields)
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form-readonly__section`
    },
    [
      renderHeader.call(this, h),
      renderContent.call(this, h)
    ]
  )
}
